<template>
  <span>
    <span
      class="classification"
      :class="getAlarmClassificationOptions.class"
      :id="componentId"
    >
      {{ getAlarmClassificationOptions.label }}
    </span>
    {{ titleHandler }}
    <b-tooltip
      v-if="showTooltip"
      custom-class="classification__tooltip"
      boundary="window"
      :placement="tooltipPlacement"
      :target="componentId"
    >
      {{ this.labelSuffix }}
    </b-tooltip>
  </span>
</template>

<script>
import { ClassificationType } from 'sigma-mappings';
import { getUniqueId } from '@/services/createId';

export default {
  props: {
    classification: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    customLabel: {
      type: String,
      default: '',
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    tooltipPlacement: {
      type: String,
      default: 'right',
    },
  },
  data: () => ({
    componentId: getUniqueId(),
  }),
  computed: {
    titleHandler() {
      return this.showLabel ? this.customLabel : this.labelSuffix;
    },
    labelSuffix() {
      if (!this.classification) return '';
      switch (this.classification) {
        case ClassificationType.ORDINARY:
          return `${this.$t('enums.commons.classification-type.ordinary')}`;
        case ClassificationType.URGENT:
          return `${this.$t('enums.commons.classification-type.urgent')}`;
        case ClassificationType.CRITICAL:
          return `${this.$t('enums.commons.classification-type.critical')}`;
        case ClassificationType.OBSERVATION:
          return `${this.$t('enums.commons.classification-type.observation')}`;
        default:
          throw new Error(`Unknown classification: "${this.classification}".`);
      }
    },
    getAlarmClassificationOptions() {
      const alarms = {
        ordinary: { class: 'classification__ordinary', label: '!' },
        urgent: { class: 'classification__urgent', label: '!!' },
        critical: { class: 'classification__critical', label: '!!!' },
        observation: { class: 'classification__observation material-icons', label: 'check' },
      };
      return alarms[this.classification] || {};
    },
  },
};

</script>

<style lang="sass" scoped>

.classification
  border-radius: 5px
  display: flex
  float: left
  margin-right: 5px
  width: 2rem
  height: 1.5rem
  justify-content: center
  color: var(--color-alarm-icon)
  line-height: 1.45rem
  font-size: 1.2rem

  &__ordinary
    background-color: var(--color-extend-blue)

  &__urgent
    background-color: var(--color-extend-orange)

  &__critical
    background-color: var(--color-extend-red)

  &__observation
    background-color: var(--color-extend-green)
    font-size: 1.43rem

  &__tooltip
    ::v-deep .tooltip-inner
      text-transform: capitalize

</style>
